"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_ORG_ERROR_NOTIFICATION = exports.GET_USER_ERROR_NOTIFICATION = exports.getUnFollowErrorNotification = exports.getFollowErrorNotification = exports.getSuccessNotificationText = exports.GET_STARTED_TEXT = exports.FOLLOW_LOGIN_MODAL_SUBTITLE_TEXT = exports.followLoginModalTitleText = exports.REJECT_TEXT = exports.ACCEPT_TEXT = exports.GDPR_SUBTITLE_TEXT = exports.GDPR_TITLE_TEXT = exports.REMOVE_ORGANIZER_CARD_TEXT = exports.FOLLOW_TEXT = exports.FOLLOWING_TEXT = exports.defaultDataPointText = exports.getFollowersCopy = exports.getUpcomingEventCopy = exports.organizerImageAltText = exports.viewOrganizerProfileString = void 0;

var _gettext = _interopRequireDefault(require("js-utils/gettext"));

var _lazyGettext = _interopRequireDefault(require("js-utils/lazy-gettext"));

var _ngettext = _interopRequireDefault(require("js-utils/ngettext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Card and Button */
var viewOrganizerProfileString = function viewOrganizerProfileString(organizerName) {
  return (0, _gettext.default)('View %(organizerName)s profile', {
    organizerName: organizerName
  });
};

exports.viewOrganizerProfileString = viewOrganizerProfileString;

var organizerImageAltText = function organizerImageAltText(organizerName) {
  return (0, _gettext.default)('%(organizerName)s profile image.', {
    organizerName: organizerName
  });
};

exports.organizerImageAltText = organizerImageAltText;

var getUpcomingEventCopy = function getUpcomingEventCopy(numUpcomingEvents) {
  return "".concat(numUpcomingEvents, " ").concat((0, _ngettext.default)('upcoming event', 'upcoming events', numUpcomingEvents));
};

exports.getUpcomingEventCopy = getUpcomingEventCopy;

var getFollowersCopy = function getFollowersCopy(numFollowers) {
  return "".concat(numFollowers, " ").concat((0, _ngettext.default)('follower', 'followers', numFollowers));
};

exports.getFollowersCopy = getFollowersCopy;
var defaultDataPointText = (0, _lazyGettext.default)('Created this event');
exports.defaultDataPointText = defaultDataPointText;
var FOLLOWING_TEXT = (0, _lazyGettext.default)('Following');
exports.FOLLOWING_TEXT = FOLLOWING_TEXT;
var FOLLOW_TEXT = (0, _lazyGettext.default)('Following');
exports.FOLLOW_TEXT = FOLLOW_TEXT;
var REMOVE_ORGANIZER_CARD_TEXT = (0, _lazyGettext.default)('Remove this organizer card');
/* GDPR Modal */

exports.REMOVE_ORGANIZER_CARD_TEXT = REMOVE_ORGANIZER_CARD_TEXT;
var GDPR_TITLE_TEXT = (0, _lazyGettext.default)('Get alerts for new events');
exports.GDPR_TITLE_TEXT = GDPR_TITLE_TEXT;
var GDPR_SUBTITLE_TEXT = (0, _lazyGettext.default)('By clicking okay, you are agreeing to receive marketing emails and notifications about creators you follow so that you don’t miss out.');
exports.GDPR_SUBTITLE_TEXT = GDPR_SUBTITLE_TEXT;
var ACCEPT_TEXT = (0, _lazyGettext.default)('Okay');
exports.ACCEPT_TEXT = ACCEPT_TEXT;
var REJECT_TEXT = (0, _lazyGettext.default)('No Thanks');
/* Login Modal */

exports.REJECT_TEXT = REJECT_TEXT;

var followLoginModalTitleText = function followLoginModalTitleText(organizerName) {
  return (0, _gettext.default)('Sign in to follow %(organizerName)s', {
    organizerName: organizerName
  });
};

exports.followLoginModalTitleText = followLoginModalTitleText;
var FOLLOW_LOGIN_MODAL_SUBTITLE_TEXT = (0, _lazyGettext.default)('Stay up on the latest from your favorite event organizers');
exports.FOLLOW_LOGIN_MODAL_SUBTITLE_TEXT = FOLLOW_LOGIN_MODAL_SUBTITLE_TEXT;
var GET_STARTED_TEXT = (0, _lazyGettext.default)('Get Started');
/* Notification */

exports.GET_STARTED_TEXT = GET_STARTED_TEXT;

var getSuccessNotificationText = function getSuccessNotificationText(name) {
  return (0, _gettext.default)('You\'re now following %(name)s. See more in your <a className="eds-link" href="/mytickets/">profile</a>', {
    name: name
  });
};

exports.getSuccessNotificationText = getSuccessNotificationText;

var getFollowErrorNotification = function getFollowErrorNotification(name) {
  return (0, _gettext.default)('Unable to follow %(name)s. Please try again in a few minutes', {
    name: name
  });
};

exports.getFollowErrorNotification = getFollowErrorNotification;

var getUnFollowErrorNotification = function getUnFollowErrorNotification(name) {
  return (0, _gettext.default)('Unable to unfollow %(name)s. Please try again in a few minutes', {
    name: name
  });
};

exports.getUnFollowErrorNotification = getUnFollowErrorNotification;
var GET_USER_ERROR_NOTIFICATION = (0, _gettext.default)('There was an error with the server. Please try again in a few minutes');
exports.GET_USER_ERROR_NOTIFICATION = GET_USER_ERROR_NOTIFICATION;
var GET_ORG_ERROR_NOTIFICATION = (0, _gettext.default)('There was an error getting the organizer info from the server. Please try again in a few minutes');
exports.GET_ORG_ERROR_NOTIFICATION = GET_ORG_ERROR_NOTIFICATION;